import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import {
  getSimStats as getSimStatsQuery,
  getTeamStats as getTeamStatsQuery,
} from '../graphql/queries'
import {
  addSimStats as addSimStatsMutation,
  updateSimStats as updateSimStatsMutation,
  addTeamStats as addTeamStatsMutation,
} from '../graphql/mutations'

export const useStats = () => {
  const client = useMemo(() => generateClient(), [])
  const addSimStats = useCallback(
    async (offeringId, numTeams) => {
      return client.graphql({
        query: addSimStatsMutation,
        variables: {
          input: {
            offeringId,
            numTeams,
          },
        },
      })
    },
    [client],
  )

  const updateSimStats = useCallback(
    async (offeringId, numNewTeams) => {
      return client.graphql({
        query: updateSimStatsMutation,
        variables: {
          input: {
            offeringId,
            numNewTeams,
          },
        },
      })
    },
    [client],
  )

  const addTeamStats = useCallback(
    async (offeringId) => {
      return client.graphql({
        query: addTeamStatsMutation,
        variables: {
          input: {
            offeringId,
          },
        },
      })
    },
    [client],
  )

  const getSimStats = useCallback(async () => {
    return client.graphql({
      query: getSimStatsQuery,
    })
  }, [client])

  const getTeamStats = useCallback(async () => {
    return client.graphql({
      query: getTeamStatsQuery,
    })
  }, [client])

  return {
    addSimStats,
    updateSimStats,
    addTeamStats,
    getSimStats,
    getTeamStats,
  }
}
